module.exports = __webpack_public_path__ + "static/media/art-show-award-1.ae7df12c.png";